import * as Sentry from '@sentry/react'
import type { ReactNode } from 'react'

// Filet de sécurité global: une erreur de rendu non rattrapée afficherait sinon
// un écran noir muet (cf. l'incident "permissionless"). Ici, on montre un écran
// lisible + un bouton de rechargement, et on remonte l'erreur à GlitchTip.

function Fallback({ error, resetError }: { error: unknown; resetError: () => void }) {
  const message = error instanceof Error ? error.message : String(error)
  return (
    <div className="mx-auto flex min-h-dvh max-w-lg flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="text-4xl">💥</div>
      <h1 className="text-lg font-black uppercase tracking-wider">Une erreur est survenue</h1>
      <p className="text-xs text-white/50">
        L'app a rencontré un problème inattendu. Il a été signalé automatiquement.
      </p>
      <pre className="max-w-full overflow-x-auto rounded-xl border border-line bg-panel p-3 text-left text-[10px] text-meme">
        {message}
      </pre>
      <div className="flex gap-2">
        <button
          onClick={resetError}
          className="rounded-xl border border-line bg-panel px-4 py-2 text-xs font-black uppercase active:scale-95"
        >
          Réessayer
        </button>
        <button
          onClick={() => window.location.reload()}
          className="rounded-xl bg-cyber px-4 py-2 text-xs font-black uppercase text-carbon active:scale-95"
        >
          Recharger
        </button>
      </div>
    </div>
  )
}

export default function AppErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => <Fallback error={error} resetError={resetError} />}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
